const rtf = new Intl.RelativeTimeFormat('es-ES', { numeric: 'auto' })

function fromNow(dateInput) {
  const date = dateInput instanceof Date ? dateInput : new Date(dateInput)
  const now = new Date()
  const diffMs = now.getTime() - date.getTime()
  const diffSec = Math.round(diffMs / 1000)
  const diffMin = Math.round(diffSec / 60)
  const diffHour = Math.round(diffMin / 60)
  const diffDay = Math.round(diffHour / 24)
  const diffMonth = Math.round(diffDay / 30)
  const diffYear = Math.round(diffDay / 365)

  if (Math.abs(diffSec) < 60) return rtf.format(-diffSec, 'second')
  if (Math.abs(diffMin) < 60) return rtf.format(-diffMin, 'minute')
  if (Math.abs(diffHour) < 24) return rtf.format(-diffHour, 'hour')
  if (Math.abs(diffDay) < 30) return rtf.format(-diffDay, 'day')
  if (Math.abs(diffMonth) < 12) return rtf.format(-diffMonth, 'month')
  return rtf.format(-diffYear, 'year')
}

function formatDate(dateInput, fmt) {
  const date = dateInput instanceof Date ? dateInput : new Date(dateInput)
  if (fmt === 'DD/MM/YYYY HH:mm') {
    return date.toLocaleString('es-ES', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      hour12: false
    }).replace(/,/g, '')
  }
  return date.toISOString()
}

export const useDayjs = () => {
  return (dateInput) => ({
    fromNow: () => fromNow(dateInput),
    format: (fmt) => formatDate(dateInput, fmt)
  })
}
